import { render, staticRenderFns } from "./SmallCalendar.vue?vue&type=template&id=3a127c5b&"
import script from "./SmallCalendar.vue?vue&type=script&lang=js&"
export * from "./SmallCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports